import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-klassendashboard-lesgroep-switch',
  templateUrl: './klassendashboard-lesgroep-switch.component.html',
  styleUrls: ['./klassendashboard-lesgroep-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KlassendashboardLesgroepSwitchComponent implements OnInit {

  @Input()
  viewmodel: LesgroepSwitchViewmodel;

  @Input()
  navigeerbaar: boolean;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public navigaarNaarVorige(): void {
    this.router.navigate([this.viewmodel.prevURL], {queryParamsHandling: 'preserve'});
  }

  public navigaarNaarVolgende(): void {
    this.router.navigate([this.viewmodel.nextURL], {queryParamsHandling: 'preserve'});
  }
}

export interface LesgroepSwitchViewmodel {
  lesgroepNaam: string;
  prevURL: string;
  nextURL: string;
}
